import PropTypes from "prop-types"
import React from "react"
import Img from "components/Img"

// Thumbnail can act as a thumbnail or as a hero, bit of a misnomer but whatevs
function Thumbnail({ thumbnail, alt, style, ...props }) {
  return (
    <div style={style} {...props}>
      <Img image={thumbnail} alt={alt} />
    </div>
  )
}

Thumbnail.propTypes = {
  thumbnail: PropTypes.shape({}).isRequired,
  /** Alt text for the thumbnail image (required for accessibility) */
  alt: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({}),
}

export default Thumbnail
